// extracted by mini-css-extract-plugin
export default {"root":"IconPhone_root__EYibH"};